import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/documail.png';

export default function Header() {
    return (
        <header className="w-full bg-white shadow-md sticky top-0 z-50">
            <div className="container mx-auto px-4 h-16 flex items-center justify-between">
                {/* Logo Section */}
                <div className="flex items-center gap-2">
                    <img src={Logo} alt="Logo" className="w-17 h-10" />
                </div>

                {/* Navigation Menu */}
                <nav className="flex items-center gap-8">
                    <Link
                        to="/"
                        className="text-gray-600 hover:text-blue-600 font-medium transition-colors duration-200"
                    >
                        Home
                    </Link>
                    <Link
                        to="/tracking"
                        className="px-4 py-2 bg-blue-50 text-blue-600 rounded-lg font-medium hover:bg-blue-100 transition-colors duration-200"
                    >
                        Tracking
                    </Link>
                </nav>
            </div>
        </header>
    );
}